<template>
  <c-page-section squares>
    <q-card data-testid="feedback">
      <q-card-section class="q-px-md">
        <div class="row items-center no-wrap">
          <div class="col">
            <div class="heading-bigger">
              {{ props.collaboratorName }}
              <span class="text-overline">{{
                formatDateForTemplate({
                  date: props.ratingDate,
                })
              }}</span>
            </div>
          </div>
        </div>
      </q-card-section>
      <q-separator />
      <q-card-section class="overflow-auto">
        <div v-for="icon of ratings" :key="icon.rank">
          <div
            v-if="props[icon.rank]"
            :class="`row justify-center items-center rating-button-wrap col max-width rating-icon active`"
          >
            <img :src="`/images/${icon.fileName}.png`" class="full-width q-pa-sm" :alt="icon.fileName" />
          </div>
        </div>
      </q-card-section>
    </q-card>
  </c-page-section>
</template>

<script lang="ts" setup>
import CPageSection from '@/components/_common/PageSection.vue';
import { formatDateForTemplate } from '@/utils';
import { ref } from 'vue';

/*****************************************************************************
 * PROPS
 ****************************************************************************/
const props = withDefaults(
  defineProps<{
    bad?: boolean;
    ok?: boolean;
    great?: boolean;
    none?: boolean;
    collaboratorName?: string;
    ratingDate?: string;
  }>(),
  {
    bad: false,
    ok: false,
    great: false,
    none: false,
    collaboratorName: '',
    ratingDate: '',
  },
);

const ratings = ref<Rating[]>([
  {
    rank: 'bad',
    fileName: 'rating-bad',
    cssClass: 'rating-bad',
  },
  {
    rank: 'ok',
    fileName: 'rating-ok',
    cssClass: 'rating-ok',
  },
  {
    rank: 'great',
    fileName: 'rating-good',
    cssClass: 'rating-good',
  },
  {
    rank: 'none',
    fileName: 'rating-none',
    cssClass: 'rating-none',
  },
]);

interface Rating {
  rank: 'bad' | 'ok' | 'great' | 'none';
  fileName: string;
  cssClass: string;
}
</script>
<style scoped lang="scss">
@import 'styles/app.variables.scss';
@import 'styles/quasar.variables.scss';
.inactive {
  opacity: 0.2;
}

.rating-icon {
  max-width: 110px;
}

.rating-description {
  min-height: 100px;
}

@media screen and (max-width: $bp600) {
  .rating-description {
    font-size: 0.95em;
  }
}

@media screen and (max-width: 660px) {
  .column .rating-description {
    min-height: 130px;
  }
}
@media screen and (max-width: 600px) {
  .column .rating-description {
    min-height: 150px;
  }
}
@media screen and (max-width: 500px) {
  .column .rating-description {
    min-height: 180px;
  }
}
@media screen and (max-width: 450px) {
  .column .rating-description {
    min-height: 220px;
  }
}
@media screen and (max-width: 400px) {
  .column .rating-description {
    min-height: 250px;
  }
}
@media screen and (max-width: 370px) {
  .column .rating-header {
    min-height: 50px;
  }
}
</style>
